import { render, staticRenderFns } from "./PaymentQueue.vue?vue&type=template&id=aa56fd88&scoped=true&"
import script from "./PaymentQueue.vue?vue&type=script&lang=js&"
export * from "./PaymentQueue.vue?vue&type=script&lang=js&"
import style0 from "./PaymentQueue.vue?vue&type=style&index=0&id=aa56fd88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa56fd88",
  null
  
)

export default component.exports